<template>
  <div class="home-section home-page pt-4 pb-4" id="homeScroll">
    <div class="fundo-efeito">

      <Banner />

      <div class="container">
        <b-row class="text-center marginBanner">
          <b-col cols="12" class="empresas zoom-on-hover" id="sobreScroll">
            <span class="text-home-h1 roboto-n">
              <span class="c-orange">Alguns de nossos </span> 
              <span style="font-weight: 900;">clientes</span><br>
              <span class="text-home-span">+ de <b>200</b> empresas atendidas</span>
            </span>
          </b-col>

          <b-col cols="6" sm="6" md="6" lg="3" xl="3" class="text-center">
            <img
              src="@/assets/img/belenus.png" 
              class="zoom-on-hover"
              width="100%"
              style="cursor: pointer;"
              @click="openLinkCliente('https://belenus.com.br')"
            >
          </b-col>

          <b-col cols="6" sm="6" md="6" lg="3" xl="3" class="text-center">
            <img
              src="@/assets/img/hidromar.png" 
              class="zoom-on-hover"
              width="100%"
              style="cursor: pointer;"
              @click="openLinkCliente('https://www.lojashidromar.com.br')"
            >
          </b-col>

          <b-col cols="6" sm="6" md="6" lg="3" xl="3" class="text-center">
            <img
            src="@/assets/img/nikkei.png" 
            class="zoom-on-hover"
            width="100%"
            style="cursor: pointer;"
            @click="openLinkCliente('https://nikkeihashimoto.com.br')"
          >
          </b-col>

          <b-col cols="6" sm="6" md="6" lg="3" xl="3" class="text-center">
            <img
              src="@/assets/img/jober.png" 
              class="zoom-on-hover"
              width="100%"
              style="cursor: pointer;"
              @click="openLinkCliente('https://jobereletrica.com.br')"
            >
          </b-col>

          <b-col cols="12">
            <iframe
              class="cardVideo"
              :src="`https://www.youtube.com/embed/${getYoutubeVideoUri('https://www.youtube.com/watch?v=W_qHKXnvhGQ')}`"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen>
            </iframe>
            <iframe 
              class="cardVideo"
              :src="`https://www.youtube.com/embed/${getYoutubeVideoUri('https://www.youtube.com/embed/Epef9MXvCi4?si=WIj88hlCsCm8UIu1')}`"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </b-col>

          <b-col cols="12">
            <div class="especialistaWhstasapp zoom-on-hover">
              <a href="https://wa.me/5519992065613"  target="_blank">
                <div class="sendQuoteWhatsapp text-center">
                  <i class="fab fa-whatsapp"></i>
                  <span class="text-cot">FALAR COM UM ESPECIALISTA</span>
                </div>
              </a>
            </div>
          </b-col>
        </b-row>

        <b-row>
        <b-col class="text-center marginCliente">
          <img src="@/assets/img/new-linha.png" class="zoom-on-hover mb-5" width="100%">
          <h1 class="text-white">Plataforma com <strong>Integrações</strong></h1>
          <span class="text-white ml-3" v-for="(ImageIntegrations, index) in ImageIntegration" :key="index">
            <img
              :src="require(`@/assets/img/integracoes/${ImageIntegrations}`)"
              class="zoom-on-hover mt-5"
              width="9%"
              style="cursor: pointer;"
            >
          </span>
          <b-row>
            <b-col cols="12" class="text-center marginCliente">
              <img src="@/assets/img/new-linha.png" class="zoom-on-hover" width="65%">
            </b-col>
          </b-row>
        </b-col>
      </b-row>


        <b-row class="d-flex justify-content-center align-items-center">
          <b-col cols="12" sm="12" md="12" lg="6" xl="6">
            <img src="@/assets/img/new-site.png" class="zoom-on-hover" width="100%">
          </b-col>

          <b-col cols="12" sm="12" md="12" lg="6" xl="6" class="qtdItens">
            <b-row class="d-flex justify-content-center align-items-center">
              <b-col cols="6" class="text-center zoom-on-hover">
                <img src="@/assets/img/new-box-icon.png"  alt="Sistema" width="50%"><br>
                <span class="text-home-label roboto-n">+ de </span>
                <span class="text-home-h2 roboto-n">1 milhão</span><br>
                <span class="text-home-h2 roboto-n">de produtos</span><br>
                <span class="text-home-h2 roboto-n">cadastrados</span><br>
              </b-col>
              <b-col cols="6" class="zoom-on-hover">
                <span class="text-home-label roboto-n">Para focar no que</span><br>
                <span class="text-home-label roboto-n">realmente importa</span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" class="text-center marginResultado" id="guiaScroll">
            <img src="@/assets/img/new-linha.png" class="zoom-on-hover" width="65%">
          </b-col>
        </b-row>

        <b-row class="d-flex justify-content-center align-items-center">
          <b-col cols="12" sm="4" md="4" lg="4" xl="4" class="text-center">
            <img src="@/assets/img/new-menu.png" class="new-menu zoom-on-hover" style="position: relative;z-index:5">
          </b-col>

          <b-col cols="12" sm="8" md="8" lg="8" xl="8">        
            <div class="card-itens roboto-n marginTop zoom-on-hover">
              <b-row class="d-flex justify-content-center align-items-center">
                <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="iconSistema">
                  <img src="@/assets/img/new-caminhao.png" width="100%" class="iconSistema">
                </b-col>

                <b-col cols="12" sm="12" md="10" lg="10" xl="10" class="textSistema">
                  <span class="card-itens-title">Sistema de frete próprio ou tercerizado</span><br>
                  <p class="card-itens-text">
                    Sistema de entrega personalizado de acordo com as regras de transporte da loja, além de contar 
                    com o frete terceirizado com a melhor envio, para oferecer as melhores opções de entrega para seus clientes.
                  </p>
                </b-col>
              </b-row>
            </div>
            
            <div class="card-itens roboto-n mt-3 zoom-on-hover">
              <b-row class="d-flex justify-content-center align-items-center">
                <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="iconSistema">
                  <img src="@/assets/img/new-card.png" width="100%" class="iconSistema">
                </b-col>
                <b-col cols="12" sm="12" md="10" lg="10" xl="10" class="textSistema">
                  <span class="card-itens-title">Split de pagamento</span><br>
                  <p class="card-itens-text">
                    Ofereça ao seu cliente um Check out otimizado para guia-los á compra, além de oferecer diversas formas de pagamento.
                  </p>
                </b-col>
              </b-row>
            </div>
            
            <div class="card-itens roboto-n mt-3 zoom-on-hover">
              <b-row class="d-flex justify-content-center align-items-center">
                <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="iconSistema">
                  <img src="@/assets/img/new-pcs.png" width="100%" class="iconSistema">
                </b-col>
                <b-col cols="12" sm="12" md="10" lg="10" xl="10" class="textSistema">
                  <span class="card-itens-title">Produtos em banco de dados</span><br>
                  <p class="card-itens-text">
                    Oferecemos um banco de dados com + de um milhão de cadastros com foto, ficha técnica, descrição e dimensões.
                    Tenha todos os produtos da sua loja física em sua loja digital economizando tempo e dinheiro.
                  </p>
                </b-col>
              </b-row>
            </div>
            
            <div class="card-itens roboto-n mt-3 zoom-on-hover">
              <b-row class="d-flex justify-content-center align-items-center">
                <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="iconSistema">
                  <img src="@/assets/img/new-edit.png" width="100%" class="iconSistema">
                </b-col>
                <b-col cols="12" sm="12" md="10" lg="10" xl="10" class="textSistema">
                  <span class="card-itens-title">Personalização instantânea</span><br>
                  <p class="card-itens-text">
                    Atualize e personalize o seu e-commerce de maneira instantânea. Toda alteração feita é atualizada na hora!
                  </p>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" class="text-center marginMetodo">
            <img src="@/assets/img/new-linha.png" class="zoom-on-hover" width="65%">
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" class="text-center metodologia zoom-on-hover">
            <span class="text-home-h3 roboto-n">
              metodologia
              <span style="font-weight: 900;">testada</span><br>
              e <span class="c-orange">comprovada</span>
            </span>
          </b-col>

          <b-col cols="12" sm="4" md="4" lg="4" xl="4">
            <div class="card-item zoom-on-hover">
              <img src="@/assets/img/new-material.png" alt="" width="100%">
              <div class="card-item-text roboto-n">
                <h1 class="card-h-format">Material físico</h1>
                <span>
                  Acreditamos que o marketing de experiência passa por um sistema híbrido entre
                   o digital e o físico, por isso entregaremos um kit inicial com camisetas, 
                   cartões de visita, wind banners, totens, banners e muito mais, com QR CODES 
                   para a sua loja e links dos seus principais contatos.
                </span>
              </div>
            </div>
          </b-col>
          
          <b-col cols="12" sm="4" md="4" lg="4" xl="4">
            <div class="card-item zoom-on-hover">
              <img src="@/assets/img/new-campanha.png" alt="" width="100%">
              <div class="card-item-text roboto-n">
                <h1 class="card-h-format">Campanhas</h1>
                <span>
                  Realizamos diversas campanhas tanto na loja física quanto na digital 
                  incentivando os clientes tanto a visitarem a loja quanto a acessar 
                  e baixar o app para fidelizá – los  no digital
                </span>
              </div>
            </div>
          </b-col>

          <b-col cols="12" sm="4" md="4" lg="4" xl="4">
            <div class="card-item zoom-on-hover">
              <img src="@/assets/img/new-editorial.png" alt="" width="100%">
              <div class="card-item-text roboto-n">
                <h1 class="card-h-format">Linha editorial</h1>
                <span>
                  A linha editorial é precisa para criar autoridade, confiança e um vínculo duradouro 
                  com seus clientes, por isso semanalmente fazemos posts para a sua rede social, com 
                  criativos elegantes e com temas variados, como dicas de construção e de produtos.
                </span>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" class="text-center marginMetodo">
            <img src="@/assets/img/new-linha.png" class="zoom-on-hover" width="65%">
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <div class="especialistaWhstasapp zoom-on-hover">
              <a href="https://wa.me/5519992065613"  target="_blank">
                <div class="sendQuoteWhatsapp text-center">
                  <i class="fab fa-whatsapp"></i>
                  <span class="text-cot">COTAR COM ESPECIALISTA</span>
                </div>
              </a>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6" xl="6" class="roboto-n" id="cotacaoScroll">
            <b-row style="color:#FFF">
              <b-col cols="12">
                <div class="cont-form form-custom">
                  <div class="form-group">
                    <label for="inputNome">Nome Completo</label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputNome"
                      placeholder="Informe seu nome completo"
                      v-model="contact.name"
                    />
                  </div>
                  <div class="form-group">
                    <label for="inputEmail">E-mail</label>
                    <input
                      type="email"
                      class="form-control"
                      id="inputEmail"
                      placeholder="seuemail@dominio.com"
                      v-model="contact.email"
                    />
                  </div>
                  <div class="form-group">
                    <label for="inputCelular">Celular</label>
                    <input
                      type="tel"
                      class="form-control"
                      id="inputCelular"
                      placeholder="(XX) XXXXX-XXXX"
                      v-mask="['(##) #####-####', '(##) ####-####']"
                      v-model="contact.phoneNumber"
                    />
                  </div>
                  <div class="form-group">
                    <label for="inputTelefone">Telefone (opcional)</label>
                    <input
                      type="tel"
                      class="form-control"
                      id="inputTelefone"
                      placeholder="(XX) XXXX-XXXX"
                      v-mask="'(##) ####-####'"
                      v-model="contact.telephone"
                    />
                  </div>
                  <div class="form-group">
                    <label for="inputEmail">Assunto</label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputAssunto"
                      placeholder="Ex: quero contratar o meu site/app"
                      v-model="contact.subject"
                    />
                  </div>
                  <div class="form-group">
                    <label for="textarea1">Mensagem</label>
                    <textarea
                      class="form-control"
                      id="textarea1"
                      rows="3"
                      v-model="contact.message"
                      placeholder="Digite sua mensagem com no mínino 10 caracteres e no máximo 1000 carecteres"
                    ></textarea>
                  </div>
                  <div class="d-flex justify-content-center">
                    <button
                      type="submit"
                      class="btn-custom"
                      style="width: 100%"
                      @click="sendContact()"
                    >
                      ENVIAR
                    </button>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6" xl="6" style="color:#FFF" class="marginTop roboto-n">
            <h1 class="font-contato">Fale <span style="font-weight: 900" class="c-orange">conosco</span></h1>
            <span>
              A Constr Up surgiu para guiar lojas assim como a sua rumo ao digital, 
              contando com uma equipe especializada na área para alavancar o seu faturamento. 
              De o seu primeiro passo para o digital!
            </span>

            <br><br><br>

            <span class="mt-4">
              <span class="contato-icon mr-2" style="padding: 15px 17px;">
                <i class="fas fa-phone-alt"></i>
              </span>
              (19) 9 9206-5613
            </span>

            <br><br><br>

            <span class="mt-4">
              <span class="contato-icon mr-2" style="padding: 15px 17px;">
                <i class="fas fa-envelope"></i>
              </span>
              contato@construp.com.br
            </span>

            <br><br><br>

            <span class="mt-4">
              <span class="contato-icon mr-2" style="padding: 15px 19px;">
                <i class="fas fa-map-marker-alt"></i>
              </span>
              1000 - Belenus - Fabrica, R.Joana Foresto Storani, Vinhedo - SP
            </span>
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- WHATSAPP -->
    <a
      href="https://wa.me/5519992065613"
      id="btn-whatssap-edge"
      target="_blank"
      rel="noopener noreferrer"
    >
      <a style="opacity: 1" id="ae_whats_btn" title="Converse conosco :)">
        <i>1</i>
      </a>
    </a>
  </div>
</template>

<script>
import Banner from "../components/Banner.vue";
import ImageIntegration from "@/enums/ImageIntegration";
import { getYoutubeVideoUri } from 'Utils/index.js';

export default {
  name: "home",
  components: {
    Banner,
  },

  data() {
    return {
      contact: {
        name: null,
        email: null,
        phoneNumber: null,
        telephone: null,
        subject: null,
        message: null,
      },
      ImageIntegration
    };
  },

  methods: {
    getYoutubeVideoUri,
    notificationPopup(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    openLinkCliente(url) {
      window.open(url, '_blank');
    },
    sendContact() {
      const self = this;
      if (!this.$validate.name(this.contact.name)) {
        this.notificationPopup('Por favor, digite um nome válido!', 'warning');
      } else if (!this.$validate.email(this.contact.email)) {
        this.notificationPopup('Por favor, digite um email válido!', 'warning');
      } else if (!this.$validate.telephone(this.contact.phoneNumber)) {
        this.notificationPopup('Por favor, digite um celular válido!', 'warning');
      } else if (
        this.contact.subject === null ||
        this.contact.subject.length <= 4 ||
        this.contact.subject.length >= 60
      ) {
        this.notificationPopup('Por favor, digite um assunto válido!', 'warning');
      } else if (
        this.contact.message === null ||
        this.contact.message.length <= 10 ||
        this.contact.message.length >= 1000
      ) {
        this.notificationPopup( 'Por favor, escreva uma mensagem válida!', 'warning');
      } else {
        this.$store.dispatch('startLoader');
        this.$store.dispatch('sendContactEmail', this.contact)
          .then(() => {
            this.contact.name = '';
            this.contact.email = '';
            this.contact.phoneNumber = '';
            this.contact.telephone = '';
            this.contact.subject = '';
            this.contact.message = '';
            setTimeout(() => {
              self.$store.dispatch('endLoader');
              self.notificationPopup('Obrigado pelo seu contato, em breve responderemos!', 'success');
            }, 1000);
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
          });
      }
    },
  }
}
</script>

<style scoped>
@import '../custom/css/home-page.css';
#homeScroll {
  overflow: hidden;
}

.contato-icon {
  background: #ff7f00;
  border-radius: 30px;
}
.zoom-on-hover {
  transition: transform 0.3s ease;
}
.zoom-on-hover:hover {
  transform: scale(1.1);
}
.empresas {
  margin-bottom: -25px
}
.font-contato {
  font-size: 3rem;
  letter-spacing: 1.5px;
}
.card-itens {
  color: #222;
  background-color: #FFF;
  padding: 5px 10px;
  border-radius: 0 10px 10px 0;
  margin-left: -7%;
  position: relative;
}
.card-itens-title {
  font-size: 1.7rem;
  font-weight: bold;
  line-height: 30px;
  letter-spacing: 1px;
}
.card-item-text {
  color: #FFF;
  padding: 5px 10px 30px 10px;
  background: #ff7f00;
  border-radius: 0 0 5px 5px;
  letter-spacing: 1.5px;
  min-height: 285px;
}
.card-itens:hover {
  border-radius: 10px;
  position: relative;
  z-index: 5;
}
.home-section {
  background-color: #000;
}
.metodologia {
  margin-bottom: 40px;
}
.fundo-efeito {
  background-image: url('../assets/img/new-banner-fundo.png');
  background-attachment: fixed;
  background-position: left top 150px;
  background-repeat: no-repeat;
  background-size: 15%;
}
.text-home-h1 {
  color: #FFF;
  font-size: 3rem;
  font-weight: 100 !important;
  line-height: 30px;
  letter-spacing: 2px;
}
.text-home-h3 {
  color: #FFF;
  font-size: 3rem;
  font-weight: 100 !important;
  line-height: 40px;
  letter-spacing: 2px;
}
.text-home-span {
  color: #FFF;
  font-size: 2rem;
  font-weight: 100 !important;
}
.text-home-h2 {
  color: #FFF;
  font-size: 1.7rem;
  font-weight: 100 !important;
  line-height: 30px;
  letter-spacing: 4px;
}
.text-home-label {
  color: #FFF;
  font-size: 1.2rem;
  font-weight: 100 !important;
  letter-spacing: 2px;
}
.home-page {
  background-image: url('../assets/img/new-banner-fundo-completo.png');
  background-attachment: fixed;
  background-position: center 130px;
  background-repeat: no-repeat;
  background-size: cover;
}
.marginCliente {
  margin-top: 130px;
  margin-bottom: 150px;
}
.marginMetodo {
  margin-top: 150px;
  margin-bottom: 150px;
}
.marginResultado {
  margin-top: 150px;
  margin-bottom: 150px;
}
.marginBanner {
  margin-top: 100px;
}
.cardVideo {
  width: 70%;
  height: 370px;
  margin-bottom: 20px;
}
.new-menu {
  width: 100%;
}
@media screen and (min-width: 600px) and (max-width: 1000px) {
  .new-menu {
    width: 100%;
  }
  .card-h-format {
    font-size: 1.5rem;
  }
  .iconSistema {
    width: 50px;
    text-align: center;
  }
  .card-itens {
    padding: 2px 5px;
    border-radius: 0 10px 10px 0;
    margin-left: -8%;
    position: relative;
  }
  .card-itens-title {
    font-size: 1.1rem;
    font-weight: bold;
    line-height: 20px;
    letter-spacing: 1px;
  }
  .card-item-text {
    color: #FFF;
    padding: 5px 10px 30px 10px;
    background: #ff7f00;
    border-radius: 0 0 5px 5px;
    letter-spacing: 1px;
    font-size: 0.8rem;
    min-height: 300px;
  }
  .card-itens-text {
    font-size: 0.7rem;
    line-height: 15px !important;
  }
  .especialistaWhstasapp  {
    padding: 0;
    margin: 15px 0;
    width: 100%;
  }
  .text-cot, .sendQuoteWhatsapp {
    font-size: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media screen and (min-width: 300px) and (max-width: 599px) {
  .especialistaWhstasapp  {
    padding: 0;
    margin: 15px 0;
    width: 100%;
  }
  .text-cot, .sendQuoteWhatsapp {
    font-size: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .new-menu {
    width: 70%;
    text-align: center;
  }
  .card-itens {
    margin-left: 0;
  }
  .card-itens-title {
    font-size: 1.0rem;
    font-weight: bold;
    line-height: 20px;
    letter-spacing: 0.9px;
  }
   .card-itens-text {
    font-size: 0.9rem;
    line-height: 20px !important;
  }
  .card-item-text {
    letter-spacing: 1px;
    font-size: 0.8rem;
    min-height: 180px;
  }
  .card-h-format {
    font-size: 1.5rem;
  }
  .marginMetodo {
    margin-top: 110px;
    margin-bottom: 110px;
  }
  .marginCliente {
    margin-top: 100px;
    margin-bottom: 120px;
  }
  .marginResultado {
    margin-top: 150px;
    margin-bottom: 110px;
  }
  .text-home-h1 {
    font-size: 2rem;
  }
  .text-home-span {
    font-size: 1.3rem;
    padding-bottom: 90px;
  }
  .empresas {
    margin-bottom: 0
  }
  .qtdItens{
    margin-top: 30px;
    text-align: center;
    margin-bottom: -50px;
  }
  .marginTop {
    margin-top: 50px;
  }
  .card-itens {
    padding: 20px 2px;
    border-radius: 10px;
    margin-left: 0;
  }
  .iconSistema {
    width: 150px;
    text-align: center;
  }
  .textSistema {
    padding: 5px 25px;
  }
  .text-home-h3 {
    font-size: 2rem;
  }
  .card-item {
    margin-bottom: 30px;
  }
  .cardVideo {
    width: 100%;
    height: 300px;
    margin-bottom: 0;
  }
}
</style>